import React, { useState, useEffect } from 'react';
import { ONE_DAY, ONE_HOUR, errorMsg, homeUrl, rearrangeArray, success } from '../utils/common_utils';
import { getAuth, getCurrentServerTime, getUIState, getUser, isLoggedIn, isValidUser, saveCommonData } from '../utils/auth_utils';
import LoginModal from '../login/email_login_modal';
import  { NavbarTop, NavbarWithOnlyHome } from '../common_components/navbar_top';
import { AI_INTERVIEWER_BOASTING, AI_INTERVIEWER_BOASTING_GPT_5, MSG_ERROR_PROGRESS_UI } from '../common_components/common_ui_components';
import { LinkUI } from '../common_components/common_links';
import { appendJSDependency, getJsonDataPostRequest, removeJSDependency } from "../utils/network_utils";
import { ModalWithCloseButton } from '../common_components/modal_with_close_button';
import { PastTransactionsListUI } from './past_transactions';
import PosthogService from '../utils/tracking_utils';
import {PaymentRegionSelect, CurrencyToggle} from './payment_regions_select';
//import posthog from '../posthog';

function PremiumHome() {
  const [transactionsList, setTransactionsList] = useState(-1);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [showProgressBar, setShowProgressBar] = useState(false);
  const [user, setUser] = useState(getUser());
  const [userLoggedIn, setUserLoggedIn] = useState(false);
  const[pricingPlans , setPricingPlans]=useState([])
  const [paymentRegionIndex, setPaymentRegionIndex]=useState(3) // USD(0), India(3)

  // index at which india is in the dropdown select, 
  // used to show india pricing
  const indiaIndex=3 

  // Payment links
  const paypal = "https://www.paypal.com/paypalme/yogpatri/25?currency_code=USD";

  function initializePaddle(){
    console.log("going to initialize paddle")
    //window.Paddle.Setup({ vendor: '198825'});
    const SANDBOX_TOKEN="test_ca5d9b77b82ea9f246ecafc41a1"
    const PRODUCTION_TOKEN="live_7bc5cd922b7acb35a7a4cb41544"
    window.Paddle.Environment.set('production') //'sandbox' 'production'
    window.Paddle.Initialize({
      token: PRODUCTION_TOKEN, // replace with a client-side token
      eventCallback: function(data) {
        console.log("Paddle event occured "+JSON.stringify(data))
        if (data.name == "checkout.completed" ||
          data.name=="checkout.loaded" || data.type=="checkout.error" 
          // || data.name=="checkout.closed"
        ) {
          sendPaddlePaymentDataToBackend(data,()=>{
            if(data.name=="checkout.completed"){
              //PosthogService.capture(data.name)
              window.location.href='/premium'
            }
          })
        }
      }
    });
    console.log("paddle has been initialized with a client side token")
  }

  /**
   * uses instamojo for india payments and paddle for rest of world payments
   */
  const makePayment = (plan, event) => {
     event.preventDefault();
     console.log("starting payment "+JSON.stringify(plan))
     if(paymentRegionIndex!=indiaIndex) makePaddlePayment(plan)
     else makeInstamojoPayment(plan)
  }
  
  /**
   * create payment url from backend and go to that url 
   */
  const makeInstamojoPayment = (plan) => {
    setShowProgressBar(true)
    let url = homeUrl()+"paymentsApi/createInstamojoPaymentUrl";
    var data={
      auth:getAuth(),
      paymentPlanId:plan.planId
    }
    getJsonDataPostRequest(url, data, function(response){
       setShowProgressBar(false)
      if(response==null||!success(response.status) || !response.paymentUrl){
          console.log(response.message | "Some error occured, please try again")
          return    
      }
      console.log("payment url created "+response.paymentUrl)
      window.location.href=response.paymentUrl
     })
  }
  
  const makePaddlePayment = (plan) => {
    console.log("inside paddle payment "+JSON.stringify(plan))
    // define items
    const SANDBOX_PRICE_ID="pri_01j5xbsbsxz9zpb3y2z550r43v"
    const PRODUCTION_PRICE_ID=plan.paddlePriceId
    let itemsList = [
      {
        priceId: PRODUCTION_PRICE_ID,
        quantity: 1
      }
    ];
    // card number is 4242 4242 4242 4242 , rest details as you wish
    window.Paddle.Checkout.open({
      items: itemsList,
      customer: {
        email: user.email,
      },
      customData: { // will be converted to custom_data , fileds remain same
        userId: ""+user.userId,
        email: user.email,
        website:"MockGym",
        premiumPlanType:""+plan.planId
      },
    });
  };

  function sendPaddlePaymentDataToBackend(jsonData, callback) {
    let url = homeUrl()+"paymentsApi/paddle/paddlePaymentFrontendData";
    var data={
      auth:getAuth(),
      json:JSON.stringify(jsonData)
    }
    getJsonDataPostRequest(url, data, function(response){
      callback()
      if(response==null||response.status>=400){
          console.log(response.message | "Some error occured, please try again")    
      }
     })
  }

  useEffect(() => {
    console.log("fetching the payments data");
    setShowProgressBar(true)
    let url = homeUrl()+"paymentsApi/fetchPaymentsHomePageData";
    getJsonDataPostRequest(url, getAuth(), function(response){
      if(response==null||response.status>=400 && response.message){
        setError(response.message)     
      }
      console.log(response.plans)
      if(response.transactions)
        setTransactionsList(response.transactions)
      setUser(response.user)
      saveCommonData(response)
      if(response.plans)
        setPricingPlans(response.plans)
      setShowProgressBar(false);
      if(!isValidUser(response.user)) return

      const paddleSrc= 'https://cdn.paddle.com/paddle/v2/paddle.js';
      setShowProgressBar(true)
      appendJSDependency(document, paddleSrc, ()=>{
      console.log("paddle dependency is added")
      initializePaddle()
      setUserLoggedIn(isLoggedIn())
      setShowProgressBar(false)
    })
    
    // Cleanup function
    return () => {
      removeJSDependency(document, paddleSrc);
    };
    });
    
    
  }, []);

  return (
    <div className="min-h-screen bg-teal-50">
      <NavbarTop />
      {/* Spacer under the navbar */}
      <div className="pt-20"></div>

      {/* Main container */}
      <div className="max-w-3xl flex flex-col mx-auto px-4">
        {/* Page title */}
        <div className="mb-6 text-center">
          <h1 className="text-5xl font-bold text-teal-800">Premium</h1>
        </div>

        {/* If not logged in, prompt login */}
        {!userLoggedIn && (
          <div className="text-center mb-6">
            <LoginModal />
          </div>
        )}

        {/* Status / Error / Progress */}
        <MSG_ERROR_PROGRESS_UI
          message={message}
          error={error}
          showProgress={showProgressBar}
        />
        { userLoggedIn && user &&
          <div>
           <InterviewCreditsUI user={user} /> 

        { /* double-bang forces a true boolean, and 0 doesn't print unnecessarily */
        !!user.interviewCreditsLeft &&
        <div className="text-sm text-center my-4 text-gray-600 italic">
          1 Mock Interview Session == 2 Interview Credits
        </div> }
           
          </div>
        }

        {userLoggedIn &&
          <ModalWithCloseButton buttonText={"Show Past Transactions"}
           >
            <PastTransactionsListUI transactions={transactionsList}/>
            </ModalWithCloseButton>
        }
        <br />
        { pricingPlans &&
           <div className='flex flex-row w-full 
           items-center justify-center'>
           {false && <span className='font-bold text-gray-700'>
            Select Region:  &nbsp; &nbsp; &nbsp; &nbsp; </span>
            }
            {
              <CurrencyToggle selectedIndex={paymentRegionIndex} 
                setSelectedIndex ={setPaymentRegionIndex} />
            }
           
           {false &&
            <PaymentRegionSelect selectedIndex={paymentRegionIndex} 
                setSelectedIndex ={setPaymentRegionIndex} />
          }
            </div> 
        }
         {/* Pricing cards – single column, multiple rows */}
         {pricingPlans &&
         <div className="flex flex-row items-center gap-6 mt-4">
          {pricingPlans.map((plan) => (
            <div
              key={plan.planId}
              className="w-full max-w-md p-6 bg-white border
               border-teal-600 rounded-lg shadow-sm leading-10 m-8"
            >
              <div className="mb-4 text-center">
              {false &&
               <div className="mb-1 text-lg font-medium text-teal-800">
                 Plan {plan.planId}
                </div>}
                <div className="mb-1 text-lg font-medium text-teal-800">
                  {plan.interviewCreditsCount/2} Interview Sessions
                </div>
              {paymentRegionIndex!=indiaIndex &&
                <div className="text-3xl font-extrabold text-teal-700">
                 {plan.currency}  {plan.finalAmount}
                </div>
              }
              {paymentRegionIndex==indiaIndex &&
                <div className="text-3xl font-extrabold text-teal-700">
                 Rs {plan.indiaPrice}
                </div>
              }
                <p className="mt-1 text-sm text-gray-700">
                  Validity: 365 days
                </p>
                
              </div>

              <hr className="my-3 border-teal-200" />

              {/* If logged in → show Pay button; else show plain link */}
              {userLoggedIn && 
                <button
                  onClick={(e) => makePayment(plan, e)}
                  className="w-full px-4 py-2 font-semibold
                   text-white transition rounded-md bg-teal-600
                   hover:bg-teal-700 focus:outline-none focus:ring-2
                   focus:ring-teal-400 focus:ring-offset-2"
                >
                  Buy
                </button>
   
             }
           
           { 
           /*  I am removing India Specific text from 
           premium page, it may be coming up as cheap or
            biased to people of other countries like 
            USA/china etc. Once people from India open the 
            payment dialog they can see India specific prices
           */
           false &&  <div className='mt-12 text-gray-500 text-center text-sm italic'>
                   **Separate Prices for India in INR 
             </div>
          }

            </div>
            
          ))}
        </div>
        }
        
        { !userLoggedIn &&
          <div className='text-center italic text-gray-700'> 
          <br />
          Please Login to Buy Interview Credits 
          <br /><br /><hr /> <br />
          <AI_INTERVIEWER_BOASTING_GPT_5 />
          </div> 
         
        }
        
        {/* Payment Card - Single Column */}
       {false &&
        <div className="flex flex-col items-center gap-6 mt-4">
          {/* Single Payment Card */}
          <div className="w-full border border-teal-600 rounded-lg p-6 shadow-sm bg-white max-w-md">
            <div className="text-center mb-4">
              <div className="text-lg font-medium text-teal-800 mb-1">
                5 Interview Sessions
              </div>
              <div className="text-3xl font-extrabold text-teal-700">
                $25
              </div>
              <p className="text-sm text-gray-700 mt-1">Validity: 365 days</p>
            </div>
            <hr className="my-3 border-teal-200" />
            <p className="text-center text-base font-medium mb-4 text-gray-800">
              Pay with PayPal:
            </p>
            <div className="flex justify-center">
              <LinkUI url={paypal} text={paypal} />
            </div>
          </div>
        </div>}

        {/* Instructions */}
       {userLoggedIn &&
        <div className="text-center mt-10 text-gray-700 leading-7">
          <span className="text-xl font-bold text-teal-600 font-mono">
            After Paying,  
          </span>
           &nbsp; Refresh this page to view Interview Credits
        </div>
         } 
        <div className="my-8"></div>
      </div>
    </div>
  );
}

/**
 * Displays remaining interview credits and payment validity date for a user.
 *
 * Props:
 *  - user: {
 *      InterviewCreditsLeft?: number,
 *      PaymentValidTill?: number | string, // epoch ms or ISO string
 *    }
 */
function InterviewCreditsUI({ user = {} }) {
  const { interviewCreditsLeft = 0, paymentValidTill=0 } = user;

  // Convert to a nice date string – e.g., 23 Apr 2025
  let formattedDate = "—";
  if (paymentValidTill) {
    const date = new Date(paymentValidTill);
    if (!isNaN(date)) {
      formattedDate = date.toLocaleDateString("en-US", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      });
    }
  }

  return (
    <div className="rounded-xl border border-gray-200 bg-white p-5 shadow-sm transition hover:shadow-md">
      {/* Header */}
      <h2 className="mb-3 text-base font-semibold text-gray-800">Account Summary</h2>

      {/* Details */}
      <dl className="space-y-2 text-sm text-gray-600">
        <div className="flex justify-between">
          <dt>Interview Credits Left</dt>
          <dd className="font-medium text-gray-900">{interviewCreditsLeft}</dd>
        </div>
        {paymentValidTill>10 &&
          <div className="flex justify-between">
          <dt>Payment Valid Till</dt>
          <dd className="font-medium text-gray-900">{formattedDate}</dd>
        </div>
        }
      </dl>

   
    </div>
  );
}

function PremiumHome1() {
  // state values decide which ui will be displayed   
  const [state, setState] = useState(-1);  
  const [transactionsList, setTransactionsList] = useState(-1);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('')
  const [showProgressBar, setShowProgressBar]=useState(false)
  console.log("going to load payment home page ")
  const[user, setUser]=useState(getUser())
  const userLoggedIn=isLoggedIn()
  const paypal="https://www.paypal.com/paypalme/yogpatri/12?currency_code=USD"
  const upi="prashant558908@okhdfcbank"

  useEffect(() => {
    console.log("fetching the payments data");
   /* if(!isLoggedIn()) {
        setState(0);
        setShowProgressBar(false)
        return;
    }
    setShowProgressBar(true)
    if(!isLoggedIn()) setState(getUIState())
    else{
      let url = homeUrl()+"paymentsApi/fetchPaymentsHomePageData";
      getJsonDataPostRequest(url, getAuth(), function(response){
        if(response==null||response.status>=400){
           setError(response.message | "Some error occured, please try again")     
        }
        setTransactionsList(response.transactions)
        setUser(getUser())
        saveCommonData(response)
        setState(getUIState())
        setShowProgressBar(false);
    })
   }*/
     
}, []); // empty bracket means there are no dependencies which will make useEffect re run

  return (
  <div>
  <NavbarTop />
  <div className='pt-20'></div>
    <div className = "flex flex-col w-screen items-center  justify-center mt-6">
      <div className="mb-8">
        <span className="text-6xl font-sans text-gray-800">
          Premium</span>
      </div>
      {!userLoggedIn &&
      <div> <LoginModal />
      <br /> </div>
      }
       
      <MSG_ERROR_PROGRESS_UI message={message} 
      error={error} showProgress={showProgressBar} />

    <div className="text-2xl text-teal-600 font-mono text-left "> Payment Options</div>
    <div className="text-sm text-gray-600 mt-2">
      PS: We are still setting up automated payments</div>
      <br />   
    <div className="flex flex-row-responsive items-center justify-center">
     <div className="flex flex-col mx-16 my-4 leading-8  
     border-2 p-4 px-8 border-teal-600">
      Amount: USD 12/- <br />
      Interview Sessions: 2 <br />
      Validity: 365 days <br />
      Pay with PayPal: <br />
      <LinkUI url={paypal} text={paypal} />
     </div>
     <div className="flex flex-col mx-4 my-4 leading-8 
     border-2 p-4 px-8 border-teal-600">
      (India Only) <br />
      Amount: Rs 800/- <br />
      Interview Sessions: 2 <br />
      Validity: 365 days <br />
      UPI: {upi} <br />
     </div>
    </div>
    <div className="text-center leading-8 text-gray-700">
      <span className="text-xl font-mono text-teal-600 font-bold">
      After Paying, </span> Please email us the transaction details at 
      &nbsp;
      <span className="text-xl font-mono text-teal-600 font-bold">
       contact@codezym.com </span>
       <br />
       We will activate premium for you within 12 hours.
      </div>
<div>
 <br /><br />
</div>
    
</div>
</div>
  );
        
}

export {PremiumHome, PremiumHome1};

